export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10969.00eb5d6c.jpg";